
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organize-care-group",
      function () {
        return require("private-next-pages/organize-care-group.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organize-care-group"])
      });
    }
  